// extracted by mini-css-extract-plugin
export default {"tableParams":"dri4jB_wEYpfkPaovYwN","controls":"qKaUCk_lOrxEpbUAZQah"};